export default __webpack_public_path__ + "static/media/oscer-pres-paediatrics.c7b061d1.svg";